export default __webpack_public_path__ + "static/media/Projects.fd746b9a.png";